import { Badge } from '../../components/ui/Badge.js';

type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;

/**
 * Maps a (configurable) ticket status name to a status-banner colour:
 * blue = in progress, orange = not started / waiting, yellow = on hold, grey = closed.
 * Matching is case-insensitive and keyword-based so variants like "Waiting on customer"
 * still resolve. Unknown statuses fall back to grey.
 */
export function ticketStatusTone(name: string | null | undefined): BadgeTone {
  const n = (name ?? '').trim().toLowerCase();
  if (!n) return 'gray';
  if (n.includes('in progress')) return 'blue';
  if (n.includes('on hold')) return 'yellow';
  if (n.includes('not started')) return 'orange';
  if (n.includes('waiting')) return 'orange';
  if (n.includes('closed')) return 'gray';
  return 'gray';
}
